module.exports = __webpack_public_path__ + "static/img/phone.2cd2ac99.svg";